var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptocurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cryptocurrency-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.898 16.7416C13.4742 17.776 11.7596 18.3331 9.99977 18.3331C8.23994 18.3331 6.52529 17.776 5.10156 16.7416M13.6529 2.50985C15.2346 3.2813 16.5315 4.5337 17.3577 6.08753C18.1839 7.64137 18.4969 9.41687 18.252 11.1596M1.74761 11.1595C1.50269 9.41679 1.81576 7.64129 2.64195 6.08745C3.46814 4.53362 4.76503 3.28122 6.34675 2.50977M14.5831 9.9998C14.5831 12.5311 12.5311 14.5831 9.99977 14.5831C7.46846 14.5831 5.41643 12.5311 5.41643 9.9998C5.41643 7.46849 7.46846 5.41646 9.99977 5.41646C12.5311 5.41646 14.5831 7.46849 14.5831 9.9998Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptocurrency);
export default __webpack_public_path__ + "static/media/cryptocurrency.ec969e0de15a27ed220b09b3ffd259d6.svg";
export { ForwardRef as ReactComponent };